<div class="kpis-spinner" *ngIf="!apexStarted">
    <mat-progress-spinner diameter="30" [mode]="'indeterminate'"></mat-progress-spinner>
</div>
<div id="graph"></div>